module.exports = __webpack_public_path__ + "static/media/lidcore-mockup-5.6536dab3.jpg";